<div #dashboard class="dashboard-widgets">
  @for (widget of (this.dashboard$ | async)?.widgets; track widget.widgetId) {
  <app-widget   
  [ngClass]="{'p-card p-component': true}"       
  styleClass="rounded-2xl shadow-sm border border-surface-200"
  [style.gridColumn]="widget.columnPosition + ' / span ' + widget.columnSpan"
  [style.gridRow]="widget.rowPosition + ' / span ' + widget.rowSpan"
  [data]="widget" 
  [isEditable]="false"></app-widget>
  }
</div>